import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BatchPrint, PrintProvider } from 'models';
import { Observable } from 'rxjs';

import { Square9ApiConfig } from './square9-api-config.model';
import { SQUARE9_API_CONFIG } from './square9-api-config.token';

/**
 * Square 9 API field service.
 */
@Injectable({
  providedIn: 'root',
})
export class Square9ApiPrintService implements PrintProvider {
  private basePath: string;

  constructor(
    private http: HttpClient,
    @Inject(SQUARE9_API_CONFIG) private config: Square9ApiConfig
  ) {
    this.config.apiUrl$.subscribe((apiUrl) => (this.basePath = apiUrl));
  }

  /**
   * Api Call to return file steam for printing.
   *
   * @param databaseId ArchiveId.
   * @param batchPrint DatabaseId.
   * @returns Application/pdf.
   */
  printDocuments(
    databaseId: number,
    batchPrint: BatchPrint
  ): Observable<object> {
    return this.http.post(
      `${this.basePath}/databases/${databaseId}/print`,
      batchPrint,
      {
        responseType: 'blob' as 'json',
      }
    );
  }
}
